var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout__auth"},[_c('router-view'),_c('loading-modal',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]}),_c('vue-snotify')],1)}
var staticRenderFns = []

export { render, staticRenderFns }